/* eslint-disable perfectionist/sort-objects */
import { defineTextStyles } from '@chakra-ui/react';

export const textStyles = defineTextStyles({
	caption: {
		value: {
			fontFamily:    'heading',
			fontSize:      '12px',
			fontWeight:    'light',
			letterSpacing: 0,
			lineHeight:    1.0,
		},
	},
	h1: {
		value: {
			fontFamily:    'heading',
			fontSize:      '32px',
			fontWeight:    'bold',
			letterSpacing: 0,
			lineHeight:    1,
		},
	},
	h2: {
		value: {
			fontFamily:    'heading',
			fontSize:      '24px',
			fontWeight:    'bold',
			letterSpacing: 0,
			lineHeight:    1,

		},
	},
	h3: {
		value: {
			fontFamily:    'heading',
			fontSize:      '20px',
			fontWeight:    'bold',
			letterSpacing: 0,
			lineHeight:    1.2,
		},
	},
	h4: {
		value: {
			fontFamily:    'heading',
			fontSize:      '16px',
			fontWeight:    'bold',
			letterSpacing: 0,
			lineHeight:    1.2,
		},
	},
	h5: {
		value: {
			fontFamily:    'heading',
			fontSize:      '14px',
			fontWeight:    'bold',
			letterSpacing: 0,
			lineHeight:    1.2,
		},
	},
	s1: {
		value: {
			fontFamily:    'heading',
			fontSize:      '32px',
			fontWeight:    'semibold',
			letterSpacing: 0,
			lineHeight:    1,
		},
	},
	s2: {
		value: {
			fontFamily:    'heading',
			fontSize:      '24px',
			fontWeight:    'semibold',
			letterSpacing: 0,
			lineHeight:    1,
		},
	},
	s3: {
		value: {
			fontFamily:    'heading',
			fontSize:      '20px',
			fontWeight:    'semibold',
			letterSpacing: 0,
			lineHeight:    1.2,
		},
	},
	s4: {
		value: {
			fontFamily:    'heading',
			fontSize:      '16px',
			fontWeight:    'semibold',
			letterSpacing: 0,
			lineHeight:    1.5,
		},
	},
	s5: {
		value: {
			fontFamily:    'heading',
			fontSize:      '14px',
			fontWeight:    'semibold',
			letterSpacing: 0,
			lineHeight:    1.5,
		},
	},
	p1: {
		value: {
			fontFamily:    'heading',
			fontSize:      '32px',
			fontWeight:    'normal',
			letterSpacing: 0,
			lineHeight:    1.2,
		},
	},
	p2: {
		value: {
			fontFamily:    'heading',
			fontSize:      '24px',
			fontWeight:    'normal',
			letterSpacing: 0,
			lineHeight:    1.2,
		},
	},
	p3: {
		value: {
			fontFamily:    'heading',
			fontSize:      '20px',
			fontWeight:    'normal',
			letterSpacing: 0,
			lineHeight:    1.2,
		},
	},
	p4: {
		value: {
			fontFamily:    'heading',
			fontSize:      '16px',
			fontWeight:    'normal',
			letterSpacing: 0,
			lineHeight:    1.5,
		},
	},
	p5: {
		value: {
			fontFamily:    'heading',
			fontSize:      '14px',
			fontWeight:    'normal',
			letterSpacing: 0,
			lineHeight:    1.5,
		},
	},
	corporate: {
		link: {
			value: {
				fontFamily:    'Poppins',
				fontSize:      '16px',
				fontWeight:    400,
				letterSpacing: '0%',
				lineHeight:    '100%',
			},
		},
		bodyXs: {
			value: {
				fontFamily:    'Poppins',
				fontSize:      '16px',
				fontWeight:    400,
				letterSpacing: '0%',
				lineHeight:    '150%',
			},
		},
		bodySm: {
			value: {
				fontFamily:    'Poppins',
				fontSize:      '18px',
				fontWeight:    400,
				letterSpacing: '0%',
				lineHeight:    '150%',
			},
		},
		bodyMd: {
			value: {
				fontFamily:    'Poppins',
				fontSize:      '20px',
				fontWeight:    400,
				letterSpacing: '0%',
				lineHeight:    '188%',
			},
		},
		bodyLg: {
			value: {
				fontFamily:    'Poppins',
				fontSize:      '35px',
				fontWeight:    400,
				letterSpacing: '0%',
				lineHeight:    '188%',
			},
		},
		heading1: {
			value: {
				fontFamily: 'Poppins',
				fontSize:   {
					base: '28px',
					md:   '40px',
				},
				fontWeight:    600,
				letterSpacing: '0%',
				lineHeight:    1.2,
			},
		},
		heading2: {
			value: {
				fontFamily:    'Poppins',
				fontSize:      '35px',
				fontWeight:    600,
				letterSpacing: '0%',
				lineHeight:    '150%',
			},
		},
		heading3: {
			value: {
				fontFamily: 'Poppins',
				fontSize:   {
					base: '22px',
					md:   '25px',
				},
				fontWeight: {
					base: 400,
					md:   600,
				},
				letterSpacing: '0%',
				lineHeight:    '150%',
			},
		},
		title: {
			value: {
				fontFamily: 'Poppins',
				fontSize:   {
					base: '28px',
					md:   '40px',
				},
				fontWeight:    700,
				letterSpacing: '0%',
				lineHeight:    {
					base: 1.2,
					md:   1.2,
				},
			},
		},
		subtitle: {
			value: {
				fontFamily: 'Poppins',
				fontSize:   {
					base: '20px',
					md:   '25px',
				},
				fontWeight:    400,
				letterSpacing: '0%',
				lineHeight:    {
					base: 1.5,
					md:   1.5,
				},
			},
		},
	},
});
